import { Button, Card, CardActions, CardContent, CardHeader, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function WhatsAppChoose({
    whatsAppPhone,
    whatsAppText,
    dialogToggleHandler,
    settings = false
}) {
    const { t } = useTranslation()
    const whatsAppStorage = localStorage.getItem("whatsapp")
    const [whatsapp, setWhatsapp] = useState(whatsAppStorage);
    const [checked, setChecked] = useState(settings);
    const [success, setSuccess] = useState(false);

    const handleChange = (event) => {
        setWhatsapp(event.target.value);
    };

    const openWhatsAppHandler = () => {
        setSuccess(false)
        if (checked) {
            localStorage.setItem("whatsapp", whatsapp)
            if (settings) {
                setTimeout(() => {
                    setSuccess(prevState => true)
                }, 500);
            }
        }
        if (whatsAppPhone) {
            let url = ``
            if (whatsapp === "WEB") {
                url = `https://web.whatsapp.com/send?phone=${whatsAppPhone}`
            } else if (whatsapp === "DESKTOP") {
                url = `whatsapp://send?phone=${whatsAppPhone}`
            }
            if (whatsAppText && whatsapp === "DESKTOP") {
                url += `&text=${whatsAppText}`
            } else if (whatsAppText && whatsapp === "WEB") {
                url += `&text=%20${whatsAppText}`
            }
            dialogToggleHandler(false)
            window.open(url)
        }
    }
    return (
        <Card>
            <CardHeader title={t("Choose how to open the whatsApp")}></CardHeader>
            <Divider />
            <CardContent>
                {success && <Typography color="success.main">{t("Updated Successfully")}</Typography>}
                <FormControl>
                    <FormLabel id="whatsapp-group-label">{t("WhatsAppHint")}</FormLabel>
                    <RadioGroup
                        aria-labelledby="whatsapp-group-label"
                        name="whatsapp"
                        value={whatsapp}
                        onChange={handleChange}
                    >
                        <FormControlLabel value="DESKTOP" control={<Radio />} label={t("WhatsApp app")} />
                        <FormControlLabel value="WEB" control={<Radio />} label={t("WhatsApp website")} />
                    </RadioGroup>
                </FormControl>
            </CardContent>
            <Divider />
            <CardActions sx={{ justifyContent: "space-between" }}>
                <FormControlLabel control={<Checkbox
                    disabled={settings}
                    checked={checked}
                    onChange={(event) => setChecked(event.target.checked)}
                    inputProps={{ 'aria-label': 'controlled' }}
                />} label={t("Make your choice default")} />
                <Button
                    variant="contained"
                    sx={{ textTransform: "none" }}
                    color="main"
                    disabled={!whatsapp || (!whatsapp && settings === false)}
                    onClick={openWhatsAppHandler}>
                    {settings ? t("Save") : t("Open")}
                </Button>
            </CardActions>
        </Card>
    )
}